import f from "../../../funcs";
import Backbone from "backbone";
import DragModal from "../DragModal";
import MainView from "./view/MainView";
import CamPhotoCollection from "./model/CamPhotoCollection";
import ControlsModel from "./model/ControlsModel";
import langDictionary from "../../lang/init";


let CamModal = DragModal.extend("CamModal", {
    cssName: "CamModal",
    width: 700
});

CamModal.prototype.init = function() {
    CamModal.__super__.init.apply(this, arguments);

    this.model = new Backbone.Model({
        width: 0,
        height: 0,
        name: "cam" + f.serverTime2clientUserDate(new Date())
    });

    this.camPhotosModel = new Backbone.Model({
        selectText: langDictionary.get("cam_photo_item_select")
    });
    this.controlsModel = new ControlsModel();
    this.camPhotoCollection = new CamPhotoCollection();

    this.view = new MainView({
        el: this.$box,
        model: this.model,
        camPhotosModel: this.camPhotosModel,
        camPhotoCollection: this.camPhotoCollection,
        controlsModel: this.controlsModel
    });

    this.view.on("select", function(capture) {
        this.trigger("select", capture);
    }.bind(this));

    this.view.render();
};

CamModal.prototype.updateSize = function() {
    if ( !this.view ) {
        return;
    }

    this.view.updateSize();
};

CamModal.prototype.on_resize = CamModal.prototype.updateSize;
CamModal.prototype.on_show = CamModal.prototype.updateSize;

export default CamModal;
